import { render, staticRenderFns } from "./more_event.vue?vue&type=template&id=cf32d31c&scoped=true"
import script from "./more_event.vue?vue&type=script&lang=js"
export * from "./more_event.vue?vue&type=script&lang=js"
import style0 from "./more_event.vue?vue&type=style&index=0&id=cf32d31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf32d31c",
  null
  
)

export default component.exports